import React, { useState, useMemo, useEffect }  from 'react';
import Modal from 'react-modal';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import jQuery from 'jquery';

import { useMsal, useAccount } from "@azure/msal-react";
import { MaterialReactTable } from 'material-react-table';

import * as Utils from '../lib/utils';
import CONFIG from '../config';
import { protectedResources } from "../config/authConfig";

window.jQuery = jQuery;
require("jsgrid");

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const modalBulkStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};


const debounce = function(fn, ms) {
  let timer
  return _ => {
    clearTimeout(timer)
    timer = setTimeout(_ => {
      timer = null
      fn.apply(this, arguments)
    }, ms)
  };
}


// const data = [];
//nested data is ok, see accessorKeys in ColumnDef below  
const SalaryGroups = () => {
    const { instance, accounts, inProgress } = useMsal();
    const account = useAccount(accounts[0] || {});

    const [dimensions, setDimensions] = useState({ 
      height: window.innerHeight,
      width: window.innerWidth
    });

    const storedYear = localStorage.getItem("salaryGroup-selectedYear");
    const [selectedYear, setSelectedYear] = useState(storedYear ? storedYear : (new Date()).getFullYear());
    
    const [tableData, setTableData] = useState([]);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);    
    const [rowCount, setRowCount] = useState(0);

    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [modalAction, setModalAction] = useState("");
    const [modalBody, setModalBody] = useState("");
    const [modalSelectedSalaryGroup, setModalSelectedSalaryGroup] = useState(null);
    const [modalTitle, setModalTitle] = useState("");

    const [modalGroupYear, setModalGroupYear] = useState((new Date()).getFullYear());
    const [modalGroupDepartment, setModalGroupDepartment] = useState("");  
    const [modalGroupName, setModalGroupName] = useState("");
    const [modalGroupDescription, setModalGroupDescription] = useState("");  

    const [modalBulkIsOpen, setBulkIsOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const [employeeRangesModalIsOpen, setEmployeeRangesModalIsOpen] = useState(false);
    const [employeeRangesData, setEmployeeRangesData] = useState([]);
    const [employeeRangesLoading, setEmployeeRangesLoading] = useState(false);
    const [employeeRangesFilter, setEmployeeRangesFilter] = useState("");
    const [employeeRangesSort, setEmployeeRangesSort] = useState({ field: null, direction: "asc" });

    let subtitle;

    
    function openBulkModal() {
      setBulkIsOpen(true);
    }     
    function afterOpenBulkModal() {
      // references are now sync'd and can be accessed.
      // subtitle.style.color = '#f00';
    }
    function closeBulkModal() {
      setBulkIsOpen(false);
    }

    async function openEmployeeRangesModal() {
      setEmployeeRangesModalIsOpen(true);
      setEmployeeRangesLoading(true);
      try {
        // Fetch employee profiles (includes their current group info from current_salary_group_id)
        const employees = await Utils.getData(
          '/api/employee/profiles/all',
          instance,
          account
        );

        // Fetch salary groups for the selected year
        const selectedYearGroups = await Utils.getData(
          '/api/salary_range_group?year=' + selectedYear,
          instance,
          account
        );

        // Fetch all salary ranges for the selected year
        const selectedYearRanges = await Utils.getData(
          '/api/salary_range?year=' + selectedYear,
          instance,
          account
        );

        // Build a lookup: group_department+group_name -> selected year group id
        const yearGroupMap = {};
        for (let i = 0; i < selectedYearGroups.length; i++) {
          const key = (selectedYearGroups[i].group_department || "").toLowerCase() + "|" + (selectedYearGroups[i].group_name || "").toLowerCase();
          yearGroupMap[key] = selectedYearGroups[i];
        }

        // Build a lookup: group_id + position_title -> range
        const rangeMap = {};
        for (let i = 0; i < selectedYearRanges.length; i++) {
          const r = selectedYearRanges[i];
          const key = r.group_id + "|" + (r.position_title || "").toLowerCase();
          rangeMap[key] = r;
        }

        // Process each employee to resolve their group and range for the selected year
        const processedData = (employees || []).map((emp) => {
          // Try to match the employee's current group to a group in the selected year
          const empGroupDept = (emp.group_department || "").toLowerCase();
          const empGroupName = (emp.group_name || "").toLowerCase();
          const lookupKey = empGroupDept + "|" + empGroupName;
          const resolvedGroup = yearGroupMap[lookupKey];

          let resolvedMinimum = null;
          let resolvedMidpoint = null;
          let resolvedMaximum = null;
          let groupResolved = true;
          let resolvedGroupName = emp.group_name || "";
          let resolvedGroupDepartment = emp.group_department || "";

          if (resolvedGroup) {
            // Found a matching group in the selected year, look up the range
            const rangeKey = resolvedGroup.id + "|" + (emp.position_title ? emp.position_title.trim() : "").toLowerCase();
            const range = rangeMap[rangeKey];



          if(emp.employee_hris_id == 3127){
            console.log("EMP", emp);
            console.log("rangeMap", rangeMap);
            console.log("rangeKey", rangeKey);
            console.log("RANGE", range);
            //rangeMap[rangeKey]
          }            

            if (range) {
              resolvedMinimum = range.minimum;
              resolvedMidpoint = range.midpoint;
              resolvedMaximum = range.maximum;
            }
          } else if (emp.group_name) {
            // Employee has a group but it doesn't exist in the selected year
            groupResolved = false;
          } else {
            // No group assigned at all
            groupResolved = false;
          }

          return {
            ...emp,
            resolved_minimum: resolvedMinimum,
            resolved_midpoint: resolvedMidpoint,
            resolved_maximum: resolvedMaximum,
            group_resolved: groupResolved,
            resolved_group_name: resolvedGroupName,
            resolved_group_department: resolvedGroupDepartment,
          };
        });

        setEmployeeRangesData(processedData);
      } catch (error) {
        console.error("Error fetching employee data:", error);
        setEmployeeRangesData([]);
      }
      setEmployeeRangesLoading(false);
    }

    function closeEmployeeRangesModal() {
      setEmployeeRangesModalIsOpen(false);
      setEmployeeRangesFilter("");
    }


    function openModal(action, groupInfo) {
      setModalAction(action);
      setModalText(action, groupInfo);
      setIsOpen(true);
    } 
    function afterOpenModal() {
      // references are now sync'd and can be accessed.
      // subtitle.style.color = '#f00';
      // console.log("Modal Contents", jQuery(".modalContents"))
    }
    function closeModal() {
      setIsOpen(false);
    }
    
    function setModalText(action, groupInfo) {
      // console.log("ACTION", action, groupInfo);
    
      let header = "";
      let body = <div>
        <div>
          <TextField
            required
            fullWidth 
            id="groupYear"
            label="Group Year"
            variant="standard"
            defaultValue={groupInfo ? groupInfo.year : ""}
            onChange={evt => setModalGroupYear(evt.target.value)} 
          /><br /><br />

          <TextField
            required
            fullWidth 
            id="groupDepartment"
            label="Group Department"
            variant="standard"
            defaultValue={groupInfo ? groupInfo.group_department : ""}
            onChange={evt => setModalGroupDepartment(evt.target.value)} 
          /><br /><br />
          
          <TextField
            required
            fullWidth 
            id="groupName"
            label="Group Name"
            variant="standard"
            defaultValue={groupInfo ? groupInfo.group_name : ""}
            onChange={evt => setModalGroupName(evt.target.value)} 
          /><br /><br />
          
          <TextField
            required
            fullWidth 
            id="groupDescription"
            label="Group Description"
            variant="standard"
            defaultValue={groupInfo ? groupInfo.group_description : ""}
            onChange={evt => setModalGroupDescription(evt.target.value)} 
          /><br /><br />

        </div>
      </div>;

      if(action==="add"){
        header = "Add a salary group.";
      }else if(action==="edit"){
        header = "Edit salary group.";
      }else if(action==="delete"){
        header = "Delete salary group?";
      }
    
      setModalGroupYear(groupInfo ? groupInfo.year : "");
      setModalGroupDepartment(groupInfo ? groupInfo.group_department : "");
      setModalGroupName(groupInfo ? groupInfo.group_name : "");
      setModalGroupDescription(groupInfo? groupInfo.group_description : "");

      setModalSelectedSalaryGroup(groupInfo);
      setModalTitle(header);
      setModalBody(body);
    
      return false;
    }
    

    const fetchData = async () => {
      if (!tableData.length) {
        setIsLoading(true);
      } else {
        setIsRefetching(true);
      }

      try {
        const jsonResponse = await Utils.getData(
          ('/api/salary_range_group?year='+selectedYear), 
          instance, 
          account
        );
        
        setTableData(jsonResponse);
        setRowCount(jsonResponse.length);        

      } catch (error) {
        setIsError(true);
        console.error(error);
        return;
      }
      setIsError(false);
      setIsLoading(false);
      setIsRefetching(false);
    };

    useEffect(() => {
      fetchData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedYear]);

    useEffect(() => {
      const debouncedHandleResize = debounce(function handleResize() {
        setDimensions({
          height: window.innerHeight,
          width: window.innerWidth
        })
      }, 500)

      //binds a resize listener for a debounced (less frequent) resize effect
      window.addEventListener('resize', debouncedHandleResize);
      
      //unbinds listener to prevent memory leaks
      return _ => {
        window.removeEventListener('resize', debouncedHandleResize)   
      };
    });

    //should be memoized or stable
    const columns = useMemo(
      () => [
        {
          accessorKey: 'delete_group',
          header: 'Delete Group',
          Cell: ({ cell, row }) => {
            return <div><a href="#" onClick={(event)=>{
              event.preventDefault();
              // console.log("EVENT", event, cell, row );
              if(window.confirm("Are you sure you would like to delete this group?")){
                deleteSalaryGroup(cell.row.original.id);
              }
              return false;
            }}>Delete</a></div>
          },
          enableEditing: false,
          columnDefType: 'display',
          enablePinning: false
        }, 
        {
          accessorKey: 'view_ranges',
          header: 'View Group Ranges',
          Cell: ({ cell }) => {
            // console.log("cell, row", cell.row, cell)
            // console.log("cell.row.original.period_start", cell.row.original.period_start.substring(0,4))
            const theYear = cell.row.original.period_start.substring(0,4);
            return <div><a href={'/salaryGroupRanges?group_id=' + cell.row.getValue("id") + '&year=' + theYear}>View</a></div>
          },
          enableEditing: false,
          columnDefType: 'display',
        },
        {
          accessorKey: 'id',
          header: 'ID',
          enableEditing: false
        },
        {
          accessorKey: 'group_department',
          header: 'Group Department',
          enableEditing: true
        },
        {
          accessorKey: 'group_name',
          header: 'Group Name',
          enableEditing: true
        },
        {
          accessorKey: 'group_description',
          header: 'Group Description',
          enableEditing: true,
        },
      ],
      [],
    );


    //saves the group to the DB and updates the client view
    function saveSalaryGroup(action, group){

      // console.log("action", action, "group", group)

      //DO THE ACTION
      let method;
      let data;

      if(action === "add"){
        method="postData";
        data = {
          period_start : modalGroupYear + "-01-01",
          period_end : modalGroupYear + "-12-31",
          group_name: modalGroupName,
          group_department: modalGroupDepartment,
          group_description: modalGroupDescription
        };
      }

      if(action === "edit"){
        method="putData";
        data = {
          id: group.id,
          period_start : group.year + "-01-01",
          period_end : group.year + "-12-31",          
          group_name: group.group_name,
          group_department: group.group_department,
          group_description: group.group_description
        };
      }

      let localSalaryGroups = Utils.copy(tableData);

      // console.log("DATA", data, instance, account)

      let url = "/api/salary_range_group";
      if(action==="edit"){
        url = url + "/" + group.id;
      }

      // console.log("IS FETCHING")

      Utils[method](url, data, instance, account).then((data) => {

        // console.log("HAS FETCHED", data);
        
        //find the group in the local list, update as needed
        let rowMatched=false;
        for(var i=0;i<localSalaryGroups.length;i++){
          if(group && localSalaryGroups[i].id===group.id){
            if(action==="edit"){
              localSalaryGroups[i] = data;
            }
            rowMatched=true;
            break;
          }
        }

        //add a group to the local list
        if(!rowMatched){
          localSalaryGroups.push(data)
        }

        setTableData(localSalaryGroups);

        closeModal();

      });

      return false;
    }


    const deleteSalaryGroup = (groupId)=>{
      Utils.deleteData(
        "/api/salary_range_group/" + groupId, 
        instance, 
        account
      ).then((data) => {
        // console.log("data", data)
        alert(data.message);

        if(data.result === "SUCCESS"){
          fetchData();
        }
      });
    }


    const handleSaveRow = async ({ exitEditingMode, row, values, table }) => {
      // console.log(row, values, table);
      // let data = table.getState().tableData; //deprecated
      let data = tableData;
      data[row.index] = values;
      setTableData([...data]);
      saveSalaryGroup("edit", values);
      exitEditingMode();
    };


    const uploadSalaryGroups = () => {
      // console.log("Do it!");
      const formData = new FormData();
      formData.append('file', selectedFile);
  
      Utils.postFile(
        "/api/salary_range_group/upload", 
        formData,
        instance,
        account
      ).then((result) => {
        alert("Salary Groups Uploaded");
        closeBulkModal();
        fetchData();
      });
      return false;
    }    

    const tableHeightValue =  window.innerHeight > 187 ? window.innerHeight - 187 : 300;
    const tableHeightCSS = tableHeightValue + "px";

    const thisYear = (new Date()).getFullYear(); 
    const yearsArray = [];
    for(let i=2022;i<=(thisYear+1);i++){
      yearsArray.push(i);
    }
    yearsArray.reverse();

    return <div>
        <Modal
          isOpen={modalIsOpen}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          style={modalStyles}
          contentLabel="Add Salary Group"
          ariaHideApp={false} // ignores need for "Modal.setAppElement('#yourAppElement');"
        >
          <div 
            className="modalContents"
            onKeyUp={(e) => { 
              // console.log("E", e);
              if (e.key === "Enter" && !e.defaultPrevented){
                saveSalaryGroup(modalAction, modalSelectedSalaryGroup);
              }
            }}
          >
            <h2 className="modalTitle" ref={(_subtitle) => (subtitle = _subtitle)}>
              {modalTitle}
            </h2>
            <div className="modalBody">
              {modalBody}
            </div>
            <div className="modalFooter" style={{float:"right"}}>

              <Button onClick={closeModal}>
                Cancel
              </Button>
              &nbsp;&nbsp;
              <Button 
                variant="contained" 
                onClick={()=>{
                // console.log("PERFORM ACTION")
                saveSalaryGroup(modalAction, modalSelectedSalaryGroup);
              }}>
                Save
              </Button>

            </div>
          </div>
        </Modal>

        <Modal
          isOpen={modalBulkIsOpen}
          onAfterOpen={afterOpenBulkModal}
          onRequestClose={closeBulkModal}
          style={modalBulkStyles}
          contentLabel="Add Salary Group Range"
          ariaHideApp={false} // ignores need for "Modal.setAppElement('#yourAppElement');"
        >
          <h2 className="modalTitle" ref={(_subtitle) => (subtitle = _subtitle)}>
            Bulk Upload
          </h2>
            <div className="modalBody">
              Please provide a CSV data file.

              <form>
                <input
                  type="file"
                  onChange={(e) => {
                    // console.log("e", e);
                    setSelectedFile(e.target.files[0])
                  }}
                />
              </form>

            </div>
            <div>&nbsp;</div>
            <div className="modalFooter">
              <button className="btn btn-primary" onClick={(event)=>{
                event.preventDefault();

                // console.log("SELECTED FILE", selectedFile);
                uploadSalaryGroups();

                return false;
              }}>OK</button>

              {/* <input type="submit" value="Upload File" class="btn btn-default" />             */}

              <button className="btn btn-primary" onClick={closeBulkModal}>Cancel</button>
            </div>
        </Modal>   

        {!employeeRangesModalIsOpen && <MaterialReactTable 
          columns={columns} 
          data={tableData}
          globalFilterFn="contains" 
          enableStickyHeader
          renderTopToolbarCustomActions={({ table }) => {
            return <div>
              <span className="sectionTableHeader">Salary Groups |</span>
              &nbsp;&nbsp;&nbsp;  

              Selected Year: <select 
              value={selectedYear}
              onChange={(event)=>{
                // console.log("event", event, event.target.value);
                localStorage.setItem("salaryGroup-selectedYear", event.target.value);
                setSelectedYear(event.target.value);
                return false;
              }}>
                {yearsArray.map((year)=>{
                  return <option key={Utils.guid()}>{year}</option>;
                })}
              </select>

              &nbsp;&nbsp;&nbsp;

              <button className="btn btn-primary"
                onClick={(event)=>{
                  openModal("add", {
                    year : (new Date()).getFullYear()
                  });
                  return false;
                }}
              >
                Add Salary Group
              </button>
              
              &nbsp;&nbsp;&nbsp;

              <button className="btn btn-primary"
                onClick={(event)=>{
                  // console.log("SHOW BULK UPLOADER", event);
                  openBulkModal();
                  return false;
                }}
              >
                Upload Salary Groups
              </button>

              &nbsp;&nbsp;&nbsp;

              <button 
                onClick={(e)=>{
                  e.preventDefault();

                  instance.acquireTokenSilent({
                    scopes: protectedResources["apiCompensation"].scopes,
                    account: account
                  }).then((msalAuthorization)=>{

                    const tokenData = "&token=" + (msalAuthorization ? msalAuthorization.accessToken : "");
                    window.location = CONFIG.API_HOST + "/api/salary_range_group?d=true&year="+selectedYear + tokenData;

                  });  

                  return false;
                }} 
                className="btn btn-primary"
              >
                Download Data
              </button>
              
              {/* <a href={"/promotionAdvancement"}>Manage Job Advancement</a> */}
              {/* &nbsp;&nbsp;&nbsp; */}
              {/* <a href={"/location"}>Manage Locations</a> */}

              &nbsp;&nbsp;&nbsp;
              <a href="/jobTitleAlias">Manage Job Title Aliases</a>
            </div>;
          }}          
          muiToolbarAlertBannerProps={
            isError
              ? {
                  color: 'error',
                  children: 'Error loading data',
                }
              : undefined
          }
          enableEditing
          onEditingRowSave={handleSaveRow}        
          muiTableContainerProps={{ sx: { height: tableHeightCSS } }}
          rowCount={rowCount}
          renderBottomToolbar={() => {
            return <div style={{ padding: "10px" }}>
              <a href="#" onClick={(e) => {
                e.preventDefault();
                openEmployeeRangesModal();
                return false;
              }}>View Employee Salary Range Assignments</a>
            </div>;
          }}
          state={{
            isLoading,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            tableData: tableData,
            // columnVisibility: { group_description: false }
          }}
        />}

        <Modal
          isOpen={employeeRangesModalIsOpen}
          onRequestClose={closeEmployeeRangesModal}
          style={{
            content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
              height: '80vh',
              width: '80%',
              overflow: 'auto',
            },
          }}
          contentLabel="Employee Salary Range Assignments"
          ariaHideApp={false}
        >
          <h2 className="modalTitle">
            Employee Salary Range Assignments ({selectedYear})
            <button className="btn btn-primary" style={{ float: "right" }} onClick={closeEmployeeRangesModal}>Close</button>
          </h2>
          <div className="modalBody">
            <div style={{ marginBottom: "10px" }}>
              <input
                type="text"
                placeholder="Filter employees..."
                value={employeeRangesFilter}
                onChange={(e) => setEmployeeRangesFilter(e.target.value)}
                style={{ padding: "5px", width: "300px" }}
              />
              &nbsp;&nbsp;
              <span>{employeeRangesData.length} total employees</span>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <span style={{ color: "red", fontWeight: "bold" }}>
                {employeeRangesData.filter(emp => !emp.resolved_minimum || !emp.resolved_midpoint || !emp.resolved_maximum).length} missing ranges
              </span>
            </div>
            {employeeRangesLoading ? (
              <p>Loading...</p>
            ) : (
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                <thead>
                  <tr style={{ borderBottom: "2px solid #999", background: "#f5f5f5" }}>
                    {[
                      { field: "name", label: "Employee Name", align: "left" },
                      { field: "employee_hris_id", label: "HRIS ID", align: "left" },
                      { field: "position_title", label: "Job Title", align: "left" },
                      { field: "resolved_group_department", label: "Department", align: "left" },
                      { field: "resolved_group_name", label: "Salary Group", align: "left" },
                      { field: "resolved_minimum", label: "Minimum", align: "right" },
                      { field: "resolved_midpoint", label: "Midpoint", align: "right" },
                      { field: "resolved_maximum", label: "Maximum", align: "right" },
                      { field: "has_range", label: "Has Range?", align: "left" },
                    ].map((col) => (
                      <th 
                        key={col.field}
                        style={{ padding: "6px", textAlign: col.align, cursor: "pointer", userSelect: "none" }}
                        onClick={() => {
                          setEmployeeRangesSort((prev) => ({
                            field: col.field,
                            direction: prev.field === col.field && prev.direction === "asc" ? "desc" : "asc",
                          }));
                        }}
                      >
                        {col.label}
                        {employeeRangesSort.field === col.field ? (employeeRangesSort.direction === "asc" ? " ▲" : " ▼") : ""}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {employeeRangesData
                    .filter((emp) => {
                      if (!employeeRangesFilter) return true;
                      const filter = employeeRangesFilter.toLowerCase();
                      return (
                        (emp.first_name && emp.first_name.toLowerCase().includes(filter)) ||
                        (emp.last_name && emp.last_name.toLowerCase().includes(filter)) ||
                        (emp.position_title && emp.position_title.toLowerCase().includes(filter)) ||
                        (emp.group_name && emp.group_name.toLowerCase().includes(filter)) ||
                        (emp.group_department && emp.group_department.toLowerCase().includes(filter)) ||
                        (String(emp.employee_hris_id).includes(filter))
                      );
                    })
                    .sort((a, b) => {
                      if (!employeeRangesSort.field) return 0;
                      const dir = employeeRangesSort.direction === "asc" ? 1 : -1;
                      let aVal, bVal;

                      switch (employeeRangesSort.field) {
                        case "name":
                          aVal = ((a.first_name || "") + " " + (a.last_name || "")).toLowerCase();
                          bVal = ((b.first_name || "") + " " + (b.last_name || "")).toLowerCase();
                          break;
                        case "has_range":
                          aVal = (a.resolved_minimum && a.resolved_midpoint && a.resolved_maximum) ? "yes" : "no";
                          bVal = (b.resolved_minimum && b.resolved_midpoint && b.resolved_maximum) ? "yes" : "no";
                          break;
                        case "resolved_minimum":
                        case "resolved_midpoint":
                        case "resolved_maximum":
                        case "employee_hris_id":
                          aVal = parseFloat(a[employeeRangesSort.field]) || 0;
                          bVal = parseFloat(b[employeeRangesSort.field]) || 0;
                          return (aVal - bVal) * dir;
                        default:
                          aVal = (a[employeeRangesSort.field] || "").toLowerCase();
                          bVal = (b[employeeRangesSort.field] || "").toLowerCase();
                      }

                      if (aVal < bVal) return -1 * dir;
                      if (aVal > bVal) return 1 * dir;
                      return 0;
                    })
                    .map((emp, idx) => {
                      const hasRange = emp.resolved_minimum && emp.resolved_midpoint && emp.resolved_maximum;
                      const groupUnresolved = !emp.group_resolved;
                      return (
                        <tr key={idx} style={{ borderBottom: "1px solid #eee", background: groupUnresolved ? "#fff8e0" : (hasRange ? "white" : "#fff3f3") }}>
                          <td style={{ padding: "5px" }}>{emp.first_name} {emp.last_name}</td>
                          <td style={{ padding: "5px" }}>{emp.employee_hris_id}</td>
                          <td style={{ padding: "5px" }}>{emp.position_title}</td>
                          <td style={{ padding: "5px" }}>{emp.resolved_group_department || ""}</td>
                          <td style={{ padding: "5px" }}>
                            {groupUnresolved 
                              ? <span style={{ color: "orange", fontWeight: "bold" }}>Can't resolve ({emp.group_name || "No group"})</span>
                              : (emp.resolved_group_name || "No group assigned")
                            }
                          </td>
                          <td style={{ padding: "5px", textAlign: "right" }}>{emp.resolved_minimum ? Utils.moneyMask(emp.resolved_minimum, 0) : ""}</td>
                          <td style={{ padding: "5px", textAlign: "right" }}>{emp.resolved_midpoint ? Utils.moneyMask(emp.resolved_midpoint, 0) : ""}</td>
                          <td style={{ padding: "5px", textAlign: "right" }}>{emp.resolved_maximum ? Utils.moneyMask(emp.resolved_maximum, 0) : ""}</td>
                          <td style={{ padding: "5px", color: groupUnresolved ? "orange" : (hasRange ? "green" : "red"), fontWeight: "bold" }}>
                            {groupUnresolved ? "Unresolved" : (hasRange ? "Yes" : "No")}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            )}
          </div>
        </Modal>
      </div>;
};

export default SalaryGroups;